export default __webpack_public_path__ + "assets/images/back.86462f.png";